import { get as httpGet, IncomingMessage, RequestOptions } from 'http';
import { parse as parseURL } from 'url';

import { isString } from 'lodash';

import { timeoutable } from './promise';
import { CHROME_WINDOWS } from './user-agent';

const BASE_HTTP_OPTIONS = {
  port: 80,
  path: '/',
  method: 'GET',
  headers: {
    'User-Agent': CHROME_WINDOWS,
  },
};

export default class HttpUtils {
  public static timeoutableGet = (
    options: RequestOptions | string | URL,
    timeout: number
  ): Promise<IncomingMessage> => {
    return timeoutable(() => HttpUtils.get(options), timeout);
  };

  public static hasRedirect(httpResp: IncomingMessage): boolean {
    return HttpUtils.isRedirectableStatus(httpResp.statusCode);
  }

  public static hasHttpsRedirect = (httpResp: IncomingMessage): boolean => {
    if (HttpUtils.hasRedirect(httpResp)) {
      const redirect = httpResp.headers.location;
      if (redirect && parseURL(redirect).protocol === 'https:') {
        return true;
      }
    }
    return false;
  };

  private static isRedirectableStatus(statusCode?: number): boolean {
    return statusCode !== undefined ? statusCode >= 300 && statusCode < 400 : false;
  }

  private static get = (options: RequestOptions | string | URL): Promise<IncomingMessage> => {
    if (HttpUtils.isRequestOptionsAsObject(options)) {
      options = { ...BASE_HTTP_OPTIONS, ...options };
    }
    return new Promise<IncomingMessage>((resolve, reject) => {
      httpGet(options, resp => resolve(resp)).on('error', (err: Error) => {
        reject(err);
      });
    });
  };

  private static isRequestOptionsAsObject = (
    toBeDetermined: RequestOptions | string | URL
  ): toBeDetermined is RequestOptions | URL => {
    return !isString(toBeDetermined);
  };
}
